import axios from 'axios'
import CartManager from '../../../../cart/cart-manager'
import getDataAttributeValue from '../../../../attributes/attributes'
import VARIANTS_TYPES from '../../config/variants-config'
import quantityInput from '../cartForm/quantityInput'
const nodeName = '.new-product-view #products_table'
export default class fastBuyCell {
    constructor(props) {
        this.cell = document.createElement('td')
        this.props = props
        this.parent = props.parent
        this.showAddToCart = props.data.options.showAddToCart
        this.formElem = document.createElement('form')
        this.addButtonElem = document.createElement('button')
        this.quantityElem = document.createElement('div')
        this.id = this.parent.id
        this.quantity = 1
        this.actionURL = getDataAttributeValue(nodeName, 'data-action-url')
        this.observer = props.observer
        this.allowDecimalQuantity = getDataAttributeValue('.new-product-card', 'data-allow-decimal')
        this.variantPackQty = parseInt(props.variantsData?.PackQty, 10) || 0
        this.hasPrice = !!(props.variantsData?.Price || props.variantsData?.BatchPrice)
    }

    getPackQty() {
        return this.variantPackQty
    }

    isPackageSelected() {
        const radio = document.querySelector('input[name="price_option"]:checked')
        return radio ? radio.value === 'package' : false
    }

    setButtonState(state) {
        this.addButtonElem.disabled = state
    }

    blockForm(state) {
        this.observer.publish('disableFastBuyButton', state)
    }

    setCurrencyCode(code) {
        this.currencyCode = code
    }

    setButtonLabel(type) {
        this.addButtonElem.innerHTML = `<i class="icon icon-${type === VARIANTS_TYPES.BUY ? 'basket' : 'quote'}"></i>`
    }

    submitForm(e) {
        e.preventDefault()
        e.stopPropagation()
        if (this.showAddToCart) {
            this.sendGeneric()
        } else {
            this.sendQuote()
        }
    }

    sendGeneric() {
        const data = {
            quantity: this.quantity.toString(),
            product: this.id.toString(),
        }
        this.postData(data)
    }

    sendQuote() {
        const quantity = this.quantity.toString()
        const variantId = this.id.toString()
        CartManager.addToCart(variantId, quantity)
    }

    postData(data) {
        this.blockForm(true)
        axios({
            method: 'post',
            url: this.actionURL,
            data: data,
        })
            .then((response) => {
                const data = response.data
                CartManager.updateCoreshopCartCount(data)
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'add_to_cart',
                        ecommerce: {
                            currency: data.currencyCode || '',
                            items: [
                                {
                                    item_id: data.id.toString(),
                                    item_name: data.name,
                                    price: data.price || '0',
                                    quantity: Number(data.qty),
                                    item_category: data.category || ''
                                }
                            ]
                        },
                    })
                }
                this.blockForm(false)
            })
            .catch((err) => {
                this.blockForm(false)
                throw err
            })
    }

    resetInput() {
        const input = this.quantityElem.querySelector('input')
        input.value = 1
        this.setQuantity(1)
    }

    setQuantity(qty) {
        this.quantity = String(qty).replace(',', '.')
    }

    resetCart() {
        this.resetInput()
        this.setQuantity(1)
        if (this.hasPrice && this.isPackageSelected() && this.variantPackQty > 1) {
            const input = this.quantityElem.querySelector('input')
            if (input) {
                const val = this.allowDecimalQuantity === '1' ? `${this.variantPackQty}.0` : String(this.variantPackQty)
                input.value = val
                this.setQuantity(val)
            }
        }
    }

    render() {
        this.cell.className = 'v-td fast-buy-cell'

        this.formElem.id = 'fast_buy_form'
        this.formElem.method = 'POST'
        this.formElem.noValidate = true

        this.quantityElem.classList.add('quantity')

        const quantityInputElem = document.createElement('input')
        quantityInputElem.type = 'text'
        quantityInputElem.disabled = false

        this.quantityElem.appendChild(quantityInputElem)

        this.addButtonElem.disabled = false
        this.addButtonElem.classList.add('add-button')
        this.addButtonElem.addEventListener('click', (e) => this.submitForm(e))
        this.addButtonElem.title = `${window.globals.trans(this.showAddToCart ? 'filter.add_to_cart' : 'filter.add_to_quote')}`
        this.setButtonLabel(this.showAddToCart ? VARIANTS_TYPES.BUY : VARIANTS_TYPES.QUOTE)

        this.formElem.appendChild(this.quantityElem)
        this.formElem.appendChild(this.addButtonElem)
        this.cell.appendChild(this.formElem)

        this.initQuantityInput()
        this.initObservers()

        return this.cell
    }

    initQuantityInput() {
        const getPackStep = () => {
            if (!this.isPackageSelected() || !this.hasPrice || this.variantPackQty <= 1) {
                return this.allowDecimalQuantity === '1' ? 0.1 : 1
            }
            return this.variantPackQty
        }

        const isPackage = this.isPackageSelected()
        const packQty = this.getPackQty()

        if (packQty > 1 && isPackage && this.hasPrice) {
            this.setQuantity(this.allowDecimalQuantity === '1' ? `${packQty}.0` : String(packQty))
        } else {
            this.setQuantity(this.allowDecimalQuantity === '1' ? '1.0' : '1')
        }

        quantityInput(
            this.formElem,
            {
                value: this.quantity,
                allowDecimalQuantity: this.allowDecimalQuantity,
                getStep: getPackStep,
                getMin: getPackStep,
            },
            this.observer,
        )
    }

    initObservers() {
        this.observer.subscribe({
            event: 'disableFastBuyButton',
            action: (state) => {
                this.setButtonState(state)
            },
        })

        this.observer.subscribe({
            event: 'resetCart',
            action: () => {
                this.resetCart()
            },
        })

        this.observer.subscribe({
            event: 'cartQuantity',
            action: ({ quantity }) => {
                let normalizedQty = quantity

                // UPDATED: allow comma only when decimal quantity is enabled
                if (this.allowDecimalQuantity === "1") {
                    normalizedQty = String(quantity).replace(',', '.')
                }

                this.setQuantity(normalizedQty)
            },
        })

        this.observer.subscribe({
            event: 'activateCart',
            action: (data) => {
                this.resetCart()
                this.setCurrencyCode(data.currencyCode)

                if (this.showAddToCart) {
                    this.setButtonLabel(VARIANTS_TYPES.BUY)
                } else {
                    this.setButtonLabel(VARIANTS_TYPES.QUOTE)
                }
                this.blockForm(false)

                if (this.hasPrice && this.isPackageSelected() && this.variantPackQty > 1) {
                    const input = this.quantityElem.querySelector('input')
                    if (input) {
                        const val = this.allowDecimalQuantity === '1' ? `${this.variantPackQty}.0` : String(this.variantPackQty)
                        input.value = val
                        this.setQuantity(val)
                    }
                }
            },
        })

        document.addEventListener('change', (e) => {
            if (e.target.name !== 'price_option') return
            const input = this.quantityElem.querySelector('input')
            if (!input) return
            const packQty = this.getPackQty()
            if (e.target.value === 'package' && packQty > 1 && this.hasPrice) {
                const val = this.allowDecimalQuantity === '1' ? `${this.variantPackQty}.0` : String(this.variantPackQty)
                input.value = val
                this.setQuantity(val)
            } else {
                const val = this.allowDecimalQuantity === '1' ? '1.0' : '1'
                input.value = val
                this.setQuantity(val)
            }
        })

        const packageLabel = document.querySelector('.npp__price-option--package')
        if (packageLabel) {
            new MutationObserver(() => {
                if (packageLabel.style.display === 'none') {
                    const input = this.quantityElem.querySelector('input')
                    if (!input) return
                    const val = this.allowDecimalQuantity === '1' ? '1.0' : '1'
                    input.value = val
                    this.setQuantity(val)
                }
            }).observe(packageLabel, { attributes: true, attributeFilter: ['style'] })
        }
    }
}
